import React from "react";
import { MultiSelectOqt } from "../";

export const SimpleSelectOqt = (props) => {
    return <MultiSelectOqt isMulti={false} {...props}/>;
}
